export default __webpack_public_path__ + "34997bcd0c478eb1fdebba5be2347398.svg";